import { useQuery } from '@tanstack/vue-query'
import { unref, type MaybeRef, type MaybeRefOrGetter, toValue } from 'vue'
import { fiatWalletsKeys } from '../fiatWalletsQueryKeys'
import { getWalletTransactions } from '../fiatWalletsEndpoints'
import type { GetTransactionsParams } from '../../types/walletTypes'

/**
 * Lazy-loadable: pass an `enabled` source (boolean / ref / getter) to gate
 * the fetch behind a tab-active or section-visible condition. Defaults to
 * `true` for backwards compatibility — existing call sites continue to
 * fetch on mount.
 */
export function useFiatWalletTransactionsQuery(
  params: MaybeRef<GetTransactionsParams>,
  enabled: MaybeRefOrGetter<boolean> = true,
) {
  return useQuery({
    queryKey: () => fiatWalletsKeys.transactions(unref(params).investorId),
    queryFn: () => getWalletTransactions(unref(params)),
    enabled: () => Boolean(unref(params).investorId) && Boolean(toValue(enabled)),
  })
}
